export default __webpack_public_path__ + "static/bg-ai-solution-with-roadmap--mobile-6d8138a576aa2dc4f3ea522ab0e282a4.jpg";